import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";

import { useGetCancellationByIdQuery } from "../../../services/cancellation/cancellationApiSlice";

import { CancellationDetailForm } from "../../../component/cancellations/cancellationDetail/CancellationDetailForm";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

import classes from "./cancellationDetailPage.module.css";
import { StatusPill } from "../../order/orderTable/orderTableColumnsConfig";
import { usePatchCancellationStatusMutation } from "../../../services/cancellation/cancellationMutationApiSlice";

const cancelledOrderconfig = {
  "cancellation requested": {
    label: "Cancellation Requested",
    bg: "#FFF4E5",
    color: "#FF9500",
    Icon: ClockIcon,
  },
  cancelled: {
    label: "Cancelled",
    bg: "#E6F7EF",
    color: "#00A167",
    Icon: CheckCircleIcon,
  },
  "cancellation rejected": {
    label: "Cancellation Rejected",
    bg: "#FDECEA",
    color: "#D92D20",
    Icon: XCircleIcon,
  },
};

export const CancellationDetailPage = () => {
  const { cancellationId } = useParams();
  const navigate = useNavigate();

  const {
    data: cancelledOrderDetail,
    isLoading,
    isError,
    isSuccess,
  } = useGetCancellationByIdQuery(cancellationId);

  const [updateCancellation, { isLoading: isUpdating }] =
    usePatchCancellationStatusMutation();

  const cancelledOrderStatusKey =
    cancelledOrderDetail?.order_status_label?.toLowerCase() ?? "";
  const cancelledOrderStatusConfig =
    cancelledOrderconfig[cancelledOrderStatusKey];

  const handleUpdate = async (payload) => {
    try {
      const response = await updateCancellation({
        id: payload.order_id,
        order_status: payload.order_status,
        remarks: payload.remarks,
      }).unwrap();

      toast.success(
        response?.message?.displayMessage || "Order updated successfully"
      );
      navigate("/cancellations");
    } catch (err) {
      toast.error(
        err?.data?.message?.displayMessage ||
          err?.error ||
          "Failed to update order"
      );
    }
  };

  return isSuccess ? (
    <div className={classes.wrapper}>
      <div className={classes.page}>
        <h2
          className={classes.pageTitle}
        >{`Cancellation ID: ${cancelledOrderDetail.id}`}</h2>
        <div className={classes.page__payment}>
          <h2 className={classes.page__payment__title}>Order: </h2>
          {cancelledOrderStatusConfig && (
            <StatusPill {...cancelledOrderStatusConfig} />
          )}
        </div>
      </div>

      <CancellationDetailForm
        initialValues={cancelledOrderDetail}
        onSubmit={handleUpdate}
        isSubmitting={isUpdating}
      />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
